import history from '../history';
import isEmpty from 'lodash/isEmpty';
import mainStore from '../containers/main/store';
import {QUERY_PARAMS} from "../constants/constants";
import {actions, labels, LessonLibraryType, PagePath} from "../constants/enums";

const ROOT = '/';


/**
 * Get the url query params
 * @returns {*}
 */
export function getQueryParams(){
    try{
        return queryParamStringToObject(window.location.search.substr(1));
    }
    catch(e){
        return undefined;
    }
}

/**
 * Remove query params from url without reloading the page
 */
export function removeQueryParams(query){
    const historyObj = queryParamStringToObject(history.location.search);
    delete historyObj[historyObj[query] ? query :`?${query}`];
    const updatedQueryParams = buildQueryParams(historyObj);
    history.replace({
        search: updatedQueryParams
    })
}
/**
 * Turn a string query param to an object
 * @param string {String}   The query param string
 */
export function queryParamStringToObject(string){
    if(isEmpty(string)){
        return {};
    }
    let queryParams = string.split('&');
    return queryParams.reduce((obj, queryParam)=>{
        let params = queryParam.split('=');
        obj[params[0]] = params[1];
        return obj
    },{})
}
/**
 * Get the current url name
 * @returns {*}
 */
export function getPathName(){
    try{
        return window.location.pathname.replace('/', '');
    }
    catch(e){
        return undefined;
    }
}

export function getCurrentPageAction(match){
    if(match.path === PagePath.LessonPlanLibrary){
        switch (match?.params?.type){
            case LessonLibraryType.MyLessons:
                return actions.FromLibrary;
            case LessonLibraryType.SharedLessons:
                return actions.FromSharedLibrary;
            case LessonLibraryType.DiscoverLessons:
            default:
                return actions.FromMusicoLibrary;
        }
    }
    let pageType = Object.keys(PagePath)[Object.values(PagePath).indexOf(match?.path)] || null;
    return `From ${pageType}`;
}


/**
 * Build the query params to be set on the url
 * @param params    {Object}  The payload object
 * @returns {string}    the formatted query params
 */
export function buildQueryParams(params={}){
    let esc = encodeURIComponent;
    return Object.keys(params).map(k => esc(k) + '=' + esc(params[k])).join('&');
}

/**
 * Navigate to new container
 * @param location {String} The location to nav to
 * @param params {Object} The query params to pass as object
 * @param saveCurrentFilePath
 * @param state {Object} The state params to pass as object
 */
let pathName = '/';
let savedSearch = '';
export function go(location, params={}, saveCurrentFilePath = false, state={}) {
    const isSignup = location.includes('signup') || location.includes('signin');
    if (pathName !== ROOT && !isSignup && !saveCurrentFilePath) {
        history.push({pathname: pathName, search: savedSearch});
        pathName = ROOT;
        savedSearch = '';
    } else {
        if (saveCurrentFilePath && window.location.pathname !== ROOT) {
            pathName = window.location.pathname;
            savedSearch = window.location.search;
        }
        if (!isEmpty(location)) {
            let path = (location.startsWith('/')) ? location : `/${location}`;
            let q = buildQueryParams(params);
            if (mainStore.isNeedToRefresh) {
                console.log('performing refresh instead of go');
                window.location.href = `${path}${q ? '?' + q : ''}`;
            } else {
                history.push({
                    pathname: path,
                    search: q,
                    state
                });
            }
        }
    }
}

export function goReplace(location) {
    history.replace({
        pathname: (location.startsWith('/')) ? location : `/${location}`
    })
}

export function goBack() {
    if (history.length <= 2) {
        go('/home');
    } else {
        history.goBack();
    }
}

export function setProjectIdCreateUrl(projectId) {
    if (window.location.pathname.includes('create')) {
        window.history.replaceState({}, document.title, window.location.pathname + '/' + projectId + window.location.search);
    }
}
